module.exports = __webpack_public_path__ + "static/media/Formular-Medium.90aad127.woff";